<template>
  <div class="mod-commission-record">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input v-model="dataForm.employeeName" :placeholder="$t('commissionRecord.employeeName')" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="dataForm.productName" :placeholder="$t('commissionRecord.productName')" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="dataForm.status" :placeholder="$t('common.status')" clearable>
          <el-option :label="$t('commissionRecord.pending')" value="PENDING"></el-option>
          <el-option :label="$t('commissionRecord.settled')" value="SETTLED"></el-option>
          <el-option :label="$t('commissionRecord.cancelled')" value="CANCELLED"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dataForm.dateRange"
          type="daterange"
          :range-separator="$t('common.to')"
          :start-placeholder="$t('common.startDate')"
          :end-placeholder="$t('common.endDate')"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">{{ $t('common.query') }}</el-button>
        <el-button type="success" @click="batchSettle()" :disabled="dataListSelections.length <= 0">{{ $t('commissionRecord.batchSettle') }}</el-button>
        <el-button type="danger" @click="batchCancel()" :disabled="dataListSelections.length <= 0">{{ $t('commissionRecord.batchCancel') }}</el-button>
        <el-button type="primary" @click="exportData()">{{ $t('common.export') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      style="width: 100%;">
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50">
      </el-table-column>
      <el-table-column
        prop="id"
        header-align="center"
        align="center"
        label="ID">
      </el-table-column>
      <el-table-column
        prop="employeeName"
        header-align="center"
        align="center"
        :label="$t('commissionRecord.employeeName')">
      </el-table-column>
      <el-table-column
        prop="productName"
        header-align="center"
        align="center"
        :label="$t('commissionRecord.productName')">
      </el-table-column>
      <el-table-column
        prop="saleQuantity"
        header-align="center"
        align="center"
        :label="$t('commissionRecord.saleQuantity')">
      </el-table-column>
      <el-table-column
        prop="saleAmount"
        header-align="center"
        align="center"
        :label="$t('commissionRecord.salesAmount')">
        <template slot-scope="scope">
          ¥{{ scope.row.saleAmount }}
        </template>
      </el-table-column>
      <el-table-column
        prop="commissionRate"
        header-align="center"
        align="center"
        :label="$t('commissionRecord.commissionRate')">
        <template slot-scope="scope">
          {{ scope.row.commissionRate }}%
        </template>
      </el-table-column>
      <el-table-column
        prop="commissionAmount"
        header-align="center"
        align="center"
        :label="$t('commissionRecord.commissionAmount')">
        <template slot-scope="scope">
          <span class="commission-amount">¥{{ scope.row.commissionAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        header-align="center"
        align="center"
        :label="$t('common.status')">
        <template slot-scope="scope">
          <el-tag :type="getStatusTag(scope.row.status)">
            {{ getStatusText(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="settlementBatch"
        header-align="center"
        align="center"
        :label="$t('commissionRecord.settlementBatch')">
      </el-table-column>
      <el-table-column
        prop="settlementTime"
        header-align="center"
        align="center"
        :label="$t('commissionRecord.settlementTime')">
        <template slot-scope="scope">
          {{ scope.row.settlementTime | dateFormat }}
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        :label="$t('common.createTime')">
        <template slot-scope="scope">
          {{ scope.row.createTime | dateFormat }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        :label="$t('common.operation')">
        <template slot-scope="scope">
          <el-button 
            v-if="scope.row.status === 'PENDING'"
            type="text" 
            size="small" 
            @click="settleHandle(scope.row.id)">
            {{ $t('commissionRecord.settleRecord') }}
          </el-button>
          <el-button 
            v-if="scope.row.status === 'PENDING'"
            type="text" 
            size="small" 
            @click="cancelHandle(scope.row.id)">
            {{ $t('commissionRecord.cancelRecord') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    
    <!-- 结算弹窗 -->
    <el-dialog
      title="提成结算"
      :visible.sync="settleVisible"
      width="50%">
      <el-form :model="settleForm" ref="settleForm" label-width="100px">
        <el-form-item label="结算批次">
          <el-input v-model="settleForm.settlementBatch" placeholder="结算批次"></el-input>
        </el-form-item>
        <el-form-item label="结算说明">
          <el-input type="textarea" v-model="settleForm.remark" placeholder="结算说明" :rows="3"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="settleVisible = false">取消</el-button>
        <el-button type="primary" @click="submitSettle">确定结算</el-button>
      </span>
    </el-dialog>
    
    <!-- 取消弹窗 -->
    <el-dialog
      title="取消提成"
      :visible.sync="cancelVisible"
      width="50%">
      <el-form :model="cancelForm" ref="cancelForm" label-width="100px">
        <el-form-item label="取消原因" prop="reason">
          <el-input type="textarea" v-model="cancelForm.reason" placeholder="取消原因" :rows="3"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelVisible = false">取消</el-button>
        <el-button type="primary" @click="submitCancel">确定取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        dataForm: {
          employeeName: '',
          productName: '',
          status: '',
          dateRange: []
        },
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        dataListLoading: false,
        dataListSelections: [],
        settleVisible: false,
        cancelVisible: false,
        settleForm: {
          settlementBatch: '',
          remark: ''
        },
        cancelForm: {
          reason: ''
        }
      }
    },
    activated () {
      this.getDataList()
    },
    methods: {
      // 获取数据列表
      getDataList () {
        this.dataListLoading = true
        const params = {
          'page': this.pageIndex,
          'limit': this.pageSize,
          'employeeName': this.dataForm.employeeName,
          'productName': this.dataForm.productName,
          'status': this.dataForm.status
        }
        
        if (this.dataForm.dateRange && this.dataForm.dateRange.length === 2) {
          params.startTime = this.dataForm.dateRange[0]
          params.endTime = this.dataForm.dateRange[1]
        }
        
        this.$http({
          url: 'commission/record/page',
          method: 'get',
          params: params
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.dataList = data.data.list
            this.totalPage = data.data.total
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.dataListLoading = false
        })
      },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      // 多选
      selectionChangeHandle (val) {
        this.dataListSelections = val
      },
      // 结算
      settleHandle (id) {
        this.settleForm = {
          settlementBatch: this.generateSettlementBatch(),
          remark: ''
        }
        this.settleVisible = true
        this.settleForm.recordIds = [id]
      },
      // 取消
      cancelHandle (id) {
        this.cancelForm = {
          reason: ''
        }
        this.cancelVisible = true
        this.cancelForm.recordIds = [id]
      },
      // 批量结算
      batchSettle () {
        if (this.dataListSelections.length <= 0) {
          this.$message.warning('请选择要结算的记录')
          return
        }
        this.settleForm = {
          settlementBatch: this.generateSettlementBatch(),
          remark: ''
        }
        this.settleVisible = true
        this.settleForm.recordIds = this.dataListSelections.map(item => item.id)
      },
      // 批量取消
      batchCancel () {
        if (this.dataListSelections.length <= 0) {
          this.$message.warning('请选择要取消的记录')
          return
        }
        this.cancelForm = {
          reason: ''
        }
        this.cancelVisible = true
        this.cancelForm.recordIds = this.dataListSelections.map(item => item.id)
      },
      // 提交结算
      submitSettle () {
        if (!this.settleForm.settlementBatch) {
          this.$message.error('请输入结算批次')
          return
        }
        this.$http({
          url: 'commission/settle',
          method: 'post',
          data: {
            recordIds: this.settleForm.recordIds,
            settlementBatch: this.settleForm.settlementBatch,
            remark: this.settleForm.remark
          }
        }).then(({data}) => {
          console.log("commission",data);
          
          if (data && data.code === 0) {
            this.$message({
              message: '结算成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.settleVisible = false
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      // 提交取消
      submitCancel () {
        if (!this.cancelForm.reason) {
          this.$message.error('请输入取消原因')
          return
        }
        this.$http({
          url: 'commission/cancel',
          method: 'post',
          data: {
            recordIds: this.cancelForm.recordIds,
            reason: this.cancelForm.reason
          }
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: '取消成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.cancelVisible = false
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      // 导出数据
      exportData () {
        const params = {
          'employeeName': this.dataForm.employeeName,
          'productName': this.dataForm.productName,
          'status': this.dataForm.status
        }
        
        if (this.dataForm.dateRange && this.dataForm.dateRange.length === 2) {
          params.startTime = this.dataForm.dateRange[0]
          params.endTime = this.dataForm.dateRange[1]
        }
        
        this.$http({
          url: 'commission/record/export',
          method: 'get',
          params: params,
          responseType: 'blob'
        }).then(({data}) => {
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = '提成记录.xlsx'
          link.click()
          window.URL.revokeObjectURL(url)
        })
      },
      // 生成结算批次号
      generateSettlementBatch () {
        const now = new Date()
        const year = now.getFullYear()
        const month = String(now.getMonth() + 1).padStart(2, '0')
        const day = String(now.getDate()).padStart(2, '0')
        const hour = String(now.getHours()).padStart(2, '0')
        const minute = String(now.getMinutes()).padStart(2, '0')
        const second = String(now.getSeconds()).padStart(2, '0')
        return `SETTLE_${year}${month}${day}${hour}${minute}${second}`
      },
      // 获取状态标签
      getStatusTag (status) {
        const tagMap = {
          'PENDING': 'warning',
          'SETTLED': 'success',
          'CANCELLED': 'danger'
        }
        return tagMap[status] || 'info'
      },
      // 获取状态文本
      getStatusText (status) {
        const textMap = {
          'PENDING': '待结算',
          'SETTLED': '已结算',
          'CANCELLED': '已取消'
        }
        return textMap[status] || status
      }
    }
  }
</script>

<style scoped>
  .commission-amount {
    font-weight: bold;
    color: #67c23a;
  }
</style>
